var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 104 104"}},[_c('g',{staticClass:"cls-1"},[_c('rect',{attrs:{"x":"2","y":"2","width":"100","height":"100"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }